import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/goodreads-g': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M42.6 403.3h2.8c12.7 0 25.5 0 38.2 0.1 1.6 0 3.1-0.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5 0.1-5.8 0.3-47-0.2-52.8l-0.9-0.3c-0.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-0.5-23.7 1.8-46.9 8.3-69.7 20.6-71.1 74.6-118.2 153.9-118.8 61.3-0.4 101.5 38.7 116.2 70.3 0.5 1.1 1.3 2.3 2.4 1.9v-61.6h44.3c0 280.3 0.1 332.2 0.1 332.2-0.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-0.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z'
      }
    ]
  }
})
